import useStoreUserEffect from './users/useStoreUserEffect.js'
import { Routes, Route } from 'react-router-dom'
import Profile from './users/Profile.js'
import CreateReferral from './referrals/CreateReferral.js';
import ReferralList from './referrals/ReferralList.js';
import ApplicantList from './referrals/ApplicantList.js';
import { Authenticated, Unauthenticated, useConvexAuth } from 'convex/react';
import "./App.css"
//import { SignInButton } from "@clerk/clerk-react";
import Home from './common/home.js'
import Login from './users/Login.js'
import AppHeader from './common/AppHeader.js'
import AppFooter from './common/AppFooter.js'
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const user = useStoreUserEffect(); 
  const { isAuthenticated }= useConvexAuth()

   if (user === null) {
      return (
      <Unauthenticated>
      <AppHeader  authenticated={isAuthenticated} />
      <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Home />} />
      </Routes>
      <AppFooter/>
   </Unauthenticated>
   )
   }
   return (
   <>
   <div className='app'>
   <div className="app-top-box">
      <AppHeader  authenticated={isAuthenticated} />
   </div>
      <div className='app-body'>
   <Authenticated>
   <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/create-referral" element={<CreateReferral />} />
      <Route path="/referrals" element={<ReferralList />} />
      <Route path="/applicants/:id" element={<ApplicantList />} />
   </Routes>
   </Authenticated>
   </div>
   </div>
   <AppFooter/>
   </>
   );
}

export default App;